import { getBorderBase, getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import Typography from 'components/Typography';
import { ICONS_MAP } from 'constants/icons';
import { COMPONENTS_NAMES } from 'theme/constants';

const prefix = ['components', COMPONENTS_NAMES.FILTERS, 'sectionHeader'];

interface IHeaderState {
  $isActive: boolean;
}

export const Container = styled.div<IHeaderState>`
  position: sticky;
  top: -4px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 10px;
  background: ${getPrefixedVar(prefix, 'base', 'bg')};
  z-index: 2;
  border-bottom-style: solid;
  ${getBorderBase([...prefix, 'base'])};

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: ${getPrefixedVar(prefix, 'active', 'bg')};
    `}
`;

export const SectionName = styled.div`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;

export const Title = styled(Typography)<IHeaderState>`
  color: ${getPrefixedVar(prefix, 'base', 'text')};

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${getPrefixedVar(prefix, 'active', 'text')};
    `}
`;

export const ArrowIcon = styled(ICONS_MAP.FillRightArrow)<IHeaderState>`
  transition: all 0.3s ease;

  ${({ $isActive }) =>
    $isActive &&
    css`
      transform: rotate(90deg);
    `}
`;
